<template>
  <div class="home-page" style="width:100%">
    <div class="b-banner">
      <div class="b-banner-con">
        <v-header></v-header>
        <v-nav></v-nav>
      </div>
      <v-slider class="b-slide-box"></v-slider>
      <!--<div class="b-banner-bg"></div>-->
    </div>
    <!--新闻 公告 -->
    <div class="b-box1 clearfix">
      <div class="b-container">
        <div class="b-main">
          <div class="b-left">
            <!-- 导航菜单 -->
            <div class="b-title">
              <div class="b-title-left">
                <div class="b-coin b-new-icon"></div>
                <div class="b-name">新闻</div>
              </div>
              <div class="b-title-right">
                <router-link to="/news">More+</router-link>
              </div>
            </div>
            <!-- 新闻列表 -->
            <div class="b-noticeList">
              <ul>
                <li v-for="item in sliceNewsList"
                    :key="item">
                  <a :href="'/detail?type=news&id='+item.newsId"
                     class="b-item-link">
                    <div class="b-left">
                      <div class="b-item-name">{{ item.title }}</div>
                    </div>
                    <div class="b-right">
                      <div class="b-date">{{ item.publish_time }}</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="b-center-fx"></div>
          <div class="b-right">
            <!-- 导航菜单 -->
            <div class="b-title">
              <div class="b-title-left">
                <div class="b-coin b-note-icon"></div>
                <div class="b-name">公告</div>
              </div>
              <div class="b-title-right">
                <router-link to="/notice">More+</router-link>
              </div>
            </div>
            <!-- 公告 -->
            <div class="b-noticeList">
              <ul>
                <li v-for="item in sliceNoticeList"
                    :key="item">
                  <a :href="'/detail?type=notice&id='+item.noticeId + '&noticeType=home_notice'"
                     class="b-item-link">
                    <div class="b-left">
<!--                      <div class="b-arrow"></div>-->
                      <div class="b-item-name">{{ item.title }}</div>
                    </div>
                    <div class="b-right">
                      <div class="b-date">{{ item.publish_time }}</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开放运行体系 -->
    <div class="b-box2 clearfix">
      <div class="b-open-container">
        <div class="b-main" style="padding-top: 10px">
          <!-- 导航菜单 -->
          <div class="b-title">
            <div class="b-title-left">
              <div class="b-coin b-kaifa-icon"></div>
              <div class="b-name">开放运行体系</div>
            </div>
          </div>
          <!-- 开放运行体系列表 -->
          <div class="b-productList clearfix">
            <ul>
              <li v-for="item in productList"
                  :key="item">
                <a :href="item.linkUrl"
                   class="b-item-link">
                  <div class="b-img">
                    <img :src="item.img"
                         alt="img">
                  </div>
                  <div class="b-item-name">{{ item.name }}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--科研成果推荐 -->
    <div class="b-box3 clearfix">
      <div class="b-container">
        <div class="b-title">
          <div class="b-keyan-title-left">
            <div class="b-coin b-keyan-icon"></div>
            <div class="b-name">技术突破</div>
          </div>
          <div class="b-title-right">
            <router-link to="/achievements">More+</router-link>
          </div>
        </div>
        <div class="b-list-3">
          <li class="clearfix" v-for="item in sliceAchievementsList"
            :key="item">
            <a :href="'/detail?type=achievements&id='+item.achievementsId"
              class="b-link-box clearfix">
              <div class="b-img">
                <img :src="item.IP_URL + '/ueditor/images/zoomin_'+ item.picture"
                        alt="img" height="210px">
              </div>
              <div class="b-info clearfix">
                <div class="b-name" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;word-break: break-all;">{{ item.title }}</div>
              </div>
            </a>
          </li>
        </div>
      </div>
    </div>
    <!--科研成果推荐 -->
    <div class="b-box3 clearfix">
      <div class="b-container">
        <div class="b-title">
          <div class="b-keyan-title-left">
            <div class="b-coin b-keyan-icon2"></div>
            <div class="b-name">科研成果</div>
          </div>
          <div class="b-title-right">
            <router-link to="/achievements10">More+</router-link>
          </div>
        </div>
        <div class="b-list-3">
          <li class="clearfix" v-for="item in sliceAchievements10List"
              :key="item">
            <a :href="'/detail?year=10&type=achievements&id='+item.achievementsId"
               class="b-link-box clearfix">
              <div class="b-img">
                <img :src="item.IP_URL + '/ueditor/images/zoomin_'+ item.picture"
                     alt="img" height="210px">
              </div>
              <div class="b-info clearfix">
                <div class="b-name" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;word-break: break-all;">{{ item.title }}</div>
              </div>
            </a>
          </li>
        </div>
      </div>
    </div>
    <!-- 数据统计 -->
    <div class="b-box4 clearfix">
      <div class="b-container">
        <div class="b-main">
          <div class="b-information">
            <ul>
              <li v-for="item in informationList"
                  :key="item">
                <a :href="item.linkUrl"
                   class="b-item-link">
                  <div class="b-top">
                    <div class="b-item-number stat-num">{{ item.number }}</div>
                  </div>
                  <div class="b-item-name">{{ item.name }}<span> / {{item.unit}}</span></div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <v-copy></v-copy>
  </div>
</template>
<script>
/* eslint-disable */
import { CountUp } from 'countup.js'
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Slider from "@/components/slider/";
import Contact from "@/components/contact/";
import Copy from "@/components/copy/"
import $ from "jquery";
export default {
  data () {
    return {
      newsList: [],
      sliceNewsList: [],
      noticeList: [],
      sliceNoticeList: [],
      productList: [],
      achievementsList: [],
      sliceAchievementsList: [],
      achievements10List: [], // 10年推荐
      sliceAchievements10List: [],  // 10年推荐
      plan: "",
      historyList: [],
      informationList: [],
      zxNum: 0,
      ptNum: 0,
      lhzxNum: 0,
      visitorNum: 0,
      stationNum: 0
    };
  },
  created(){
    setTimeout(() => {
      this.countUp()
    });
  },
  mounted () {
    //this.$message.success("推荐使用 Google 浏览器。");

    var self = this;
    $.ajax({
      url: Header.IP_URL + '/news/simpleList',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.newsList = res.data;
      self.sliceNewsList = self.newsList.slice(0, 10);
      for(var i=0;i < self.sliceNewsList.length; i++){
        self.sliceNewsList[i].publish_time = self.sliceNewsList[i].publish_time.substring(0,10);
      }
    }).fail(function () {
      console.log('失败');
    });

    $.ajax({
      url: Header.IP_URL + '/notice/simpleList',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.noticeList = res.data;
      self.sliceNoticeList = self.noticeList.slice(0, 10);
      for(var i=0;i < self.sliceNoticeList.length; i++){
        self.sliceNoticeList[i].publish_time = self.sliceNoticeList[i].publish_time.substring(0,10);
      }
    }).fail(function () {
      console.log('失败');
    });

    $.ajax({
      url: Header.IP_URL + '/achievements/simpleList?scienceRecommend=1',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.achievementsList = res.data;
      self.sliceAchievementsList = self.achievementsList.slice(0, 4);
      for(var i=0;i < self.achievementsList.length; i++){
        if(self.achievementsList[i].picture == null || self.achievementsList[i].picture =="") {
          self.achievementsList[i].picture = "default_new_pic.jpg";
        }
        self.achievementsList[i].IP_URL = Header.IP_URL;
      }
    }).fail(function () {
      console.log('失败');
    });

    $.ajax({
      url: Header.IP_URL + '/achievements/simpleList?recommend=1',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.achievements10List = res.data;
      self.sliceAchievements10List = self.achievements10List.slice(0, 4);
      for(var i=0;i < self.achievements10List.length; i++){
        if(self.achievements10List[i].picture == null || self.achievements10List[i].picture =="") {
          self.achievements10List[i].picture = "default_new_pic.jpg";
        }
        self.achievements10List[i].IP_URL = Header.IP_URL;
      }
    }).fail(function () {
      console.log('失败');
    });

    $.ajax({
      url: Header.IP_URL + '/stats/detail?statsId=1',
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.zxNum = res.data.zxNum;
      self.ptNum = res.data.ptNum;
      self.lhzxNum = res.data.lhzxNum;
      self.visitorNum = res.data.visitorNum;
      self.stationNum = res.data.stationNum;
      // 数据统计
      self.informationList = [
        {
          linkUrl: "/zxs",
          number: self.zxNum,
          unit: '个',
          name: '技术中心'
        },
        {
          linkUrl: "/pts",
          number: self.ptNum,
          unit: '个',
          name: '公共仪器平台'
        },
        // {
        //   linkUrl: "#",
        //   number: self.visitorNum,
        //   unit: '人次',
        //   name: '访客'
        // },
        {
          linkUrl: "/activity",
          number: self.lhzxNum,
          unit: '个',
          name: '联合研究中心'
        },
        {
          linkUrl: "/kyuser3",
          number: self.stationNum,
          unit: '个',
          name: '用户工作站'
        }
      ]
    }).fail(function () {
      console.log('失败');
    });


    // 开发运行列表
    this.productList = [
      {
        linkUrl: "/pts",
        img: require('../../assets/img/icon47.png'),
        name: "仪器平台"
      },
      {
        linkUrl: "/zxs",
        img: require('../../assets/img/icon48.png'),
        name: "技术服务"
      },
      {
        linkUrl: "/service11",
        img: require('../../assets/img/laboratory.png'),
        name: "共享实验室"
      },
      {
        linkUrl: "/event2",
        img: require('../../assets/img/icon50.png'),
        name: "开放研究计划与对外合作"
      },
      {
        linkUrl: "/sciences?category=hdyg",
        img: require('../../assets/img/icon51.png'),
        name: "科学普及"
      }
    ];

    this.plan = "";
    // 十年展
    this.historyList = [
    ];

  },
  methods:{
    countUp() {
      var options = {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
      }
      var eles = document.querySelectorAll('.stat-num');
      console.log('eles', eles)
      for (var i = 0, l = eles.length; i < l; i++) {
        var t = this.informationList[i].number;
        console.log('---t', t);

        var c = new CountUp(eles[i], t, options);
        if (!c.error) {
          c.start();
        } else {
          console.error(c.error);
        }
      }

    }
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-slider": Slider,
    "v-contact": Contact,
    "v-copy": Copy
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/base.css";
/* 图标 */
.b-new-icon{
  background: url(../../assets/img/icon52.png) no-repeat!important;
  background-size: cover!important;
}
.b-note-icon{
  background: url(../../assets/img/icon53.png) no-repeat!important;
  background-size: cover!important;
}
.b-kaifa-icon{
  width: 35px!important;
  height: 35px!important;
  background: url(../../assets/img/icon46.png) no-repeat!important;
  background-size: cover!important;
}

.b-keyan-icon{
  width: 35px!important;
  height: 35px!important;
  background: url(../../assets/img/icon54.png) no-repeat!important;
  background-size: cover!important;
}

.b-keyan-icon2{
  width: 35px!important;
  height: 35px!important;
  background: url(../../assets/img/star.png) no-repeat!important;
  background-size: cover!important;
}
/* 导航一屏  */
.b-banner{
  position: relative;
  .b-head-top{
    //position: absolute;
    //width: 100%;
    width: 1340px;
    left: 0;
    top: 40px;
    z-index: 10;
  }

  @media screen and (max-width:600px) {
    .b-slide-box {
      position: relative;
      height: calc(100% - 134px);
      z-index: 1;
      width: 1300px;
    }
    .b-banner-con {
      //padding: 22px 0;
      background: url(../../assets/img/banner_bg.png) no-repeat !important;
      background-size: cover !important;

      .b-header {
        margin-bottom: 0px;
      }

      height: 134px;
      width: 1440px;
    }
  }

  @media screen and (min-width:960px) {
    .b-slide-box {
      position: relative;
      height: calc(100% - 134px);
      z-index: 1;
    }
    .b-banner-con {
      //padding: 22px 0;
      background: url(../../assets/img/banner_bg.png) no-repeat !important;
      background-size: cover !important;

      .b-header {
        margin-bottom: 0px;
      }

      height: 134px;
    }
  }


  .b-banner-bg{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    //background: rgba(5,90,146,0.55);
    z-index: 2;
  }
}

/* 导航菜单 */
.b-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 30px;
  .b-title-left {
    display: flex;
    align-items: center;
    border-bottom: solid 3px rgb(12, 92, 200);
  }
  .b-keyan-title-left {
    display: flex;
    align-items: center;
    border-bottom: solid 3px rgb(12, 92, 200);
    margin-left: 573px;
  }
  .b-keyan-title-left2 {
    display: flex;
    align-items: center;
    border-bottom: solid 3px rgb(12, 92, 200);
    margin-left: 323px;
  }
  .b-coin {
    width: 30px;
    height: 30px;
    background: url(../../assets/img/coin.png) no-repeat;
    background-size: contain;
  }
  .b-name {
    text-align: inherit;
    font-weight: bold;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    line-height: 2;
    display: inline-block;
    color: rgb(12, 92, 200);
    padding-left: 10px;
    font-size: 26px;
  }
  .b-title-right {
    text-align: inherit;
    font-weight: normal;
    font-family: microsoft yahei;
    line-height: inherit;
    display: inline-block;
    color: #000;
    font-size: 14px;
    width: 55px;
    height: 19px;
  }
}

/* 分割线 */
.b-center-fx {
  width: 1px;
  height: 350px;
  border-left: 1px solid #ddd;
  margin-top: 85px;
}
/* 新闻 */
.b-box1 .b-main {
  margin-top: 10px;
  margin-bottom: 50px;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  .b-left {
    width: 600px;
  }
  .b-right {
    width: 520px;
  }
}
/* 新闻列表 */
.newsList ul li {
  border-bottom: 1px solid #ddd;
  margin-bottom: 5px;
  padding-bottom: 5px;
  .b-item-name {
    text-align: left;
    color: rgb(54, 43, 43);
    font-size: 13px;
    font-weight: bold;
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    &:hover {
      color: #2ba8e2;
      text-decoration: none;
      cursor: pointer;
    }
  }
  .b-item-des {
    text-align: left;
    color: #666;
    font-size: 12px;
    line-height: inherit;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    overflow: hidden;
  }
}

/* 公告 */
.b-noticeList ul li .b-item-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  .b-item-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .b-left {
    display: flex;
    align-items: center;
    width: 79%;
  }
  .b-arrow {
    width: 20px;
    height: 20px;
    background: url(../../assets/img/arrow.png) no-repeat;
    background-size: contain;
  }
  .b-item-name {
    text-align: left;
    color: #000;
    font-size: 14px;
    //font-weight: bold;
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    &:hover {
      color: #2ba8e2;
      text-decoration: none;
      cursor: pointer;
    }
  }
  .b-date {
    color: #666;
    font-size: 13px;
    line-height: 20px;
    text-align: right;
  }
}

/* 开放运行 */
.b-box2 .b-title {
  justify-content: center;
}
.b-box2 .b-productList ul {
  margin: 0 -10px;
  height: 260px;
  overflow: hidden;
  li {
    width: 20%;
    float: left;
    margin: 20px 0;
    .b-item-link {
      margin: 0 8px;
      //border: 1px solid #ddd;
      display: block;
      padding: 20px 10px;
      height: auto;
      overflow: hidden;
    }
    .b-img {
      //border: 3px solid rgb(204, 204, 204);
      border-radius: 100%;
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      img {
        width: 70px;
      }
    }

    .b-item-name {
      text-align: center;
      color: rgb(102, 102, 102);
      font-size: 18px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      margin: 15px 0 10px;
      &:hover {
        color: #004098;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .b-item-des {
      text-align: center;
      color: #666;
      font-size: 12px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      word-break: break-all;
      overflow: hidden;
    }
  }
}
/* 科研成果推荐 */
.b-box3{
  margin-bottom: 40px;
  .b-column-box{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 20px;
    .b-coin{
      width: 35px;
      height: 35px;
      background: url(../../assets/img/icon54.png) no-repeat!important;
      background-size: cover!important;
    }
    .b-name{
      padding-left: 10px;
      color: #000;
      font-size: 26px;
      font-weight: bold
    }
  }
  .b-list-3{
    margin-left: -10px;
    margin-right: -10px;
    margin-top: 35px;
    display: flex;
    flex-wrap: wrap;
    li{
      width: 25%;
      float: left;
      list-style: none;
      padding: 10px;
      .b-link-box{
        display: block;
        border: 1px solid rgba(221,221,221,1);
        box-shadow: 0 2px 10px rgba(0,0,0,0.15);
        .b-info{
          padding: 10px;
          .b-name{
            font-size: 14px;
            color: #000;
            line-height: 32px;
          }
        }
      }
    }
  }
}

/* STAR计划 十年展 */
.b-box3 .b-main {
  margin-top: 90px;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  .b-left {
    width: 750px;
    /* STAR计划 */
    .b-plan {
      color: #000;
      font-size: 16px;
      line-height: 25px;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 11;
      word-break: break-all;
      overflow: hidden;
    }
  }
  .b-right {
    width: 370px;
  }
}
/* 十年展 */
.b-historyList {
  .b-item-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
  }
  .b-left {
    display: flex;
    align-items: center;
    width: 80%;
    .b-arrow {
      width: 20px;
      height: 20px;
      background: url(../../assets/img/arrow.png) no-repeat;
      background-size: contain;
    }
    .b-item-name {
      text-align: left;
      color: #000;
      font-size: 13px;
      font-weight: bold;
      height: 25px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      &:hover {
        color: #2ba8e2;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
  .b-right .b-date {
    color: #666;
    font-size: 12px;
    line-height: 20px;
    text-align: right;
  }
}
/* 数据统计 */
.b-box4 {
  margin: 20px 0 90px 0;
  .b-information ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .b-top {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .b-item-number {
      color: rgb(12, 92, 200);
      font-size: 50px;
      font-weight: bold;
      font-family: arial;
      display: block;
      line-height: inherit;
      padding-top: 3px;
      margin-right: 10px;
    }
    .b-item-name {
      color: rgb(35, 39, 61);
      font-size: 18px;
      font-weight: normal;
      font-family: Avenir, Helvetica, Arial, sans-serif;
      display: block;
      line-height: inherit;
      padding-top: 5px;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue